export default "__VITE_ASSET__4c5ed150__"